<div (click)="doClose($event)" [class.c-dialog--show]="visible()" class="c-dialog">
	<div class="c-dialog__content">
		<div class="c-dialog__header">
			<p class="u-title-sub">{{ title() }}</p>

			<button (click)="doClose()" class="c-btn-link">
				<tvcore-icon name="close"></tvcore-icon>
			</button>
		</div>

		<ng-content></ng-content>
	</div>
</div>
